import { render } from "./LanguageSelectorComponent.vue?vue&type=template&id=22d96d13&ts=true"
import script from "./LanguageSelectorComponent.vue?vue&type=script&lang=ts"
export * from "./LanguageSelectorComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__